export default __webpack_public_path__ + "static/media/288.3e1429be.png";